var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M6 0h-6v6h6v-6zM5 5h-4v-4h4v4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M2 2h2v2h-2v-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M0 16h6v-6h-6v6zM1 11h4v4h-4v-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M2 12h2v2h-2v-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M10 0v6h6v-6h-6zM15 5h-4v-4h4v4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M12 2h2v2h-2v-2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M2 7h-2v2h3v-1h-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M7 9h2v2h-2v-2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M3 7h2v1h-2v-1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M9 12h-2v1h1v1h1v-1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M6 7v1h-1v1h2v-2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M8 4h1v2h-1v-2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M9 8v1h2v-2h-3v1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M7 6h1v1h-1v-1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M9 14h2v2h-2v-2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M7 14h1v2h-1v-2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M9 11h1v1h-1v-1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M9 3v-2h-1v-1h-1v4h1v-1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M12 14h1v2h-1v-2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M12 12h2v1h-2v-1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M11 13h1v1h-1v-1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M10 12h1v1h-1v-1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M14 10v1h1v1h1v-2h-1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M15 13h-1v3h2v-2h-1z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M10 10v1h3v-2h-2v1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M12 7v1h2v1h2v-2h-2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.dbd80c49.svg";
export { ForwardRef as ReactComponent };